export class Step {
    key: string;
    state: string;
    component?: any;
    require?: string;
    beforeDisplay?: string;

    constructor(key: string, // key is required
        require?: string,
        beforeDisplay?: string,
        state: string = 'inactive', // state has a default value
        component?: any, // the rest are optional
    ) {
        this.key = key;
        this.state = state;
        this.component = component;
        if (require) this.require = require;
        if (beforeDisplay) this.beforeDisplay = beforeDisplay;
    }
}